<template>
    <div class="copy-input control has-icons-left">
        <input class="input" type="text" :value="copyText" readonly @click="copy">
        <span class="icon is-small is-left">
            <i class="far fa-clone"></i>
        </span>
        <p class="help is-success" v-if="isSuccess">{{ successText }}</p>
    </div>
</template>

<script>

export default {
    name: "CopyInput",
    props: {
        copyText: {
            type: String,
            default: '',
        },
        successText: {
            type: String,
            default: 'Скопировано',
        }
    },
    data() {
        return {
            isSuccess: false,
            showSuccessTimeout: null,
        }
    },
    methods: {
        copy() {
            clearTimeout(this.showSuccessTimeout);
            let el = document.createElement('textarea');

            el.value = this.copyText;
            document.body.appendChild(el);

            // Выделим текст в поле
            el.select();
            // Для мобильных устройств
            el.setSelectionRange(0, this.copyText.length);

            document.execCommand('copy');
            document.body.removeChild(el);

            this.isSuccess = true;
            this.showSuccessTimeout = setTimeout(() => {
                this.isSuccess = false;
            }, 2000);
        }
    },
}
</script>

<style scoped lang="scss">
@import "../../../sass/variables";

.copy-input {
    width: 100%;
    position: relative;

    .help {
        position: absolute;
        left: 0;
        bottom: 100%;
    }
}

.bulma .copy-input input {
    border: 1px solid $tests-light-grey;
    box-sizing: border-box;
    border-radius: 6px;
    box-shadow: none;
}
</style>